//
//
//
//
//

    import {getToken} from '@/api/index'
    import config from '@/config/index'

    export default {
        data() {
            return {}
        },
        mounted() {
            if (localStorage.token) { // 如果有token去重定向页面
                this.$router.replace({
                    path: '/index'//重定向页面的地址
                })
            } else { // 没有token 去获取code和token
                if (!this.$route.query.code) { // 首次进来没有code 如果没有code，去调微信接口获取code
                    this._getCode()
                } else { // 微信重定向回来第二次进来有code，和后台交换token
                    this._getToken()
                }
            }
        },
        methods: {
            async _getToken() {
                this.$vux.loading.show({
                    text: '授权中...'
                });
                let code = this.$route.query.code;
//                console.log(code);
                // const datas = {code: code, mpid: config.mpid, appid: config.appid}
                // console.log(datas)
                await
                    getToken({
                        code,
                    }).then((res) => {
//                        console.log(res);
                        this.$vux.loading.hide()
                        if (res.data.token) localStorage.token = res.data.token;//参考后台给的数据的接口写token
                        this.$router.push('/index') // 路由地址到重定向页面的地址
                        console.log( res.data.token)
                    })
            },
            _getCode() {
                localStorage.token = '';
                localStorage.removeItem('token');
       window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri=' + config.loginUrl + '/getToken' + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
                // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri=' + config.loginUrl + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
            }
        },
        components: {}
    }



// WEBPACK FOOTER //
// ./src/pages/getToken/getToken.vue